/** The user "Diagnose" tab — thin adapter over features/ai-diag (shared
 *  entity_diagnose backend tool; see the bookings variant). */
import { useMemo } from 'react';

import * as usersApi from '@/api/users';
import { AiDiagChat } from '@/features/ai-diag/AiDiagChat';
import type { AiDiagAdapter } from '@/features/ai-diag/types';

export function AiDiagnosePanel({ userId }: { userId: number }) {
  const adapter: AiDiagAdapter = useMemo(
    () => ({
      launchContext: usersApi.diagnoseLaunchContext,
      start: (body) => usersApi.startDiagnose(userId, body),
      taskType: 'entity_diagnose',
      subjectNoun: 'user',
      subjectTitle: `User ${userId}`,
      questionPlaceholder: 'e.g. "Why can’t this guest log in?"',
      labelContains: `[user:${userId}]`,
      matchesSubject: (params) => (params as { user_id?: number } | null)?.user_id === userId,
    }),
    [userId],
  );
  return (
    <AiDiagChat
      adapter={adapter}
      subjectNote={
        'The AI reads this user’s profile, change history, bookings & orders, ' +
        'permissions, login sessions, devices, mobile-cache state and backend ' +
        'logs — nothing else.'
      }
    />
  );
}
